import api from "./api";

class TerminiPagamentoManager {

    terminiDiPagamento(config?: any) {
        return api.get(`/termini_pagamento`, config)
    }

    termineDiPagamento(id: number | string, config?: any) {
        return api.get(`/termini_pagamento/${id}`, config)
    }

    retrieve = this.termineDiPagamento
    list = this.terminiDiPagamento
    paginatedList = this.terminiDiPagamento
}

const terminiPagamentoManager = new TerminiPagamentoManager()

export default terminiPagamentoManager
